import { useKinderConnectCaptureChildrenQuery } from '@famly/stat_kinder-connect-capture_data';
import { adaptKinderConnectCaptureChildrenQueryToSettingsChildren } from './adapt-kinder-connect-capture-children-query-to-settings-children';
/**
 * Returns every child at the given site along with their current capture-enabled flag, for the
 * capture settings modal's list and filter.
 *
 * Search and the "only enabled" filter are applied client-side by the caller, not passed to this
 * hook -- the list is scoped to one site, small enough for that to stay true.
 *
 * @param siteId - The site to fetch children for.
 * @returns The site's children, in the same {data, loading, error} shape a query hook returns.
 */
export const useKinderConnectCaptureSettingsChildrenList = (siteId) => {
    const { data, loading, error } = useKinderConnectCaptureChildrenQuery({ variables: { siteId }, skip: !siteId });
    return {
        data: data
            ? {
                children: adaptKinderConnectCaptureChildrenQueryToSettingsChildren(data.attendance.childCheckins.kinderConnectCaptureChildren),
            }
            : undefined,
        loading,
        error,
    };
};
